module.exports = __webpack_public_path__ + "ec14115fe72ea1f1016f9e3c9018a9ec.svg";